<div class="formdaterange" [ngStyle]="field.containerStyles">

  <mat-form-field class="form-field" [formGroup]="group"
    [ngStyle]="field.date1Styles.container" [color]="field.color">
    <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.date1Styles.input"
      [required]="field.required" [matDatepicker]="picker1" [formControlName]="field.name" [placeholder]="field.label">
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
    <mat-hint></mat-hint>
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
  </mat-form-field>

  <mat-form-field *ngIf="field.field2.visible" class="form-field" [formGroup]="group"
    [ngStyle]="field.date2Styles.container" [color]="field.color">
    <input matInput [gioEnableControl]="isEnabledFn(field.field2.name, field.field2.id)"
      [ngStyle]="field.date2Styles.input" [required]="field.field2.required" [matDatepicker]="picker2"
      [formControlName]="field.field2.name" [placeholder]="field.field2.label">
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
    <mat-hint></mat-hint>
    <ng-container *ngFor="let validation of field.field2.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.field2.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
  </mat-form-field>
</div>
